(function () {
  function initTerminal(terminal) {
    if (!terminal || terminal.dataset.apReady === "true") return;

    var form = terminal.querySelector("[data-ap-form]");
    var input = terminal.querySelector("[data-ap-input]");
    var maskDisplay = terminal.querySelector("[data-ap-mask-display]");
    var verifyButton = terminal.querySelector("[data-ap-verify]");
    var resetButton = terminal.querySelector("[data-ap-reset]");
    var statusText = terminal.querySelector("[data-ap-status-text]");
    var loading = terminal.querySelector("[data-ap-loading]");
    var stageLabel = terminal.querySelector("[data-ap-stage]");
    var meter = terminal.querySelector("[data-ap-meter]");
    var meterSegments = terminal.querySelectorAll("[data-ap-meter] span");
    var progressReadout = terminal.querySelector("[data-ap-progress]");
    var result = terminal.querySelector("[data-ap-result]");
    var copyButton = terminal.querySelector("[data-ap-copy]");
    var deploymentCodeElement = terminal.querySelector(
      "[data-ap-deployment-code-value]",
    );

    if (
      !form ||
      !input ||
      !maskDisplay ||
      !verifyButton ||
      !resetButton ||
      !statusText ||
      !loading ||
      !stageLabel ||
      !meter ||
      !meterSegments.length ||
      !progressReadout ||
      !result ||
      !copyButton ||
      !deploymentCodeElement
    ) {
      return;
    }

    terminal.dataset.apReady = "true";

    var validCode = normalizeCode(terminal.dataset.validCode || "");
    var verifyLabel = terminal.dataset.verifyLabel || "VERIFY RECOVERY CODE";
    var recoveryData = {
      archiveRecord: terminal.dataset.archiveRecord || "",
      recoveredArtifact: terminal.dataset.recoveredArtifact || "",
      artifactName: terminal.dataset.artifactName || "",
      classification: terminal.dataset.classification || "",
      deploymentCredit: terminal.dataset.deploymentCredit || "",
      deploymentCode: terminal.dataset.deploymentCode || "",
      artifactStatus: terminal.dataset.artifactStatus || "",
    };
    var stages = [
      "INITIALIZING RECOVERY HANDSHAKE",
      "AUTHENTICATING ARCHIVE SIGNATURE",
      "TRACING PROTOTYPE 001 RECORD",
      "DECRYPTING ARTIFACT MANIFEST",
      "VERIFYING DEPLOYMENT CLEARANCE",
      "RECONSTRUCTING RECOVERY DOCUMENT",
    ];
    var prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    var segmentDelay = prefersReducedMotion ? 45 : 380;
    var completionDelay = prefersReducedMotion ? 100 : 350;
    var timers = [];
    var maskTimer = null;
    var maskDelay = 700;
    var previousInputValue = "";
    var isRunning = false;
    var lifecycleVersion = 0;

    function normalizeCode(value) {
      return value.trim().toUpperCase();
    }

    function schedule(callback, delay) {
      var timer = window.setTimeout(callback, delay);
      timers.push(timer);
      return timer;
    }

    function clearTimers() {
      timers.forEach(function (timer) {
        window.clearTimeout(timer);
      });
      timers = [];
    }

    function clearMaskTimer() {
      if (maskTimer === null) return;
      window.clearTimeout(maskTimer);
      maskTimer = null;
    }

    function syncMaskScroll() {
      maskDisplay.scrollLeft = input.scrollLeft;
    }

    function renderMaskedValue(revealIndex) {
      var value = input.value;
      var safeRevealIndex =
        typeof revealIndex === "number" &&
        revealIndex >= 0 &&
        revealIndex < value.length
          ? revealIndex
          : -1;

      if (!value) {
        maskDisplay.textContent = "";
        maskDisplay.scrollLeft = 0;
        return;
      }

      if (safeRevealIndex === -1) {
        maskDisplay.textContent = "*".repeat(value.length);
      } else {
        maskDisplay.textContent =
          "*".repeat(safeRevealIndex) +
          value.charAt(safeRevealIndex) +
          "*".repeat(value.length - safeRevealIndex - 1);
      }

      syncMaskScroll();
    }

    function maskAllCharacters() {
      clearMaskTimer();
      renderMaskedValue(-1);
    }

    function updateMaskedDisplay(event) {
      var value = input.value;
      var inputType = event.inputType || "";
      var isDeletion =
        inputType.indexOf("delete") === 0 ||
        (!inputType && value.length < previousInputValue.length);
      var isInsertion = !inputType || inputType.indexOf("insert") === 0;

      clearMaskTimer();
      previousInputValue = value;

      if (!value || isDeletion || !isInsertion) {
        renderMaskedValue(-1);
        return;
      }

      var selectionEnd =
        typeof input.selectionStart === "number"
          ? input.selectionStart
          : value.length;
      var revealIndex = Math.max(0, selectionEnd - 1);

      renderMaskedValue(revealIndex);
      maskTimer = window.setTimeout(function () {
        maskTimer = null;
        renderMaskedValue(-1);
      }, maskDelay);
    }

    function setStatus(message, state) {
      terminal.classList.toggle("is-error", state === "error");
      terminal.classList.toggle("is-success", state === "success");
      statusText.textContent = "STATUS: " + message;
    }

    function setVerifyLabel(label) {
      verifyButton.textContent = "[ " + label + " ]";
    }

    function resetMeter() {
      meterSegments.forEach(function (segment) {
        segment.classList.remove("is-active");
      });
      meter.setAttribute("aria-valuenow", "0");
      progressReadout.textContent = "000%";
    }

    function updateMeter(completedSegments) {
      var progress = Math.round(
        (completedSegments / meterSegments.length) * 100,
      );

      meterSegments.forEach(function (segment, index) {
        segment.classList.toggle("is-active", index < completedSegments);
      });
      meter.setAttribute("aria-valuenow", String(progress));
      progressReadout.textContent = String(progress).padStart(3, "0") + "%";
    }

    function populateRecoveryRecord() {
      Object.keys(recoveryData).forEach(function (fieldName) {
        terminal
          .querySelectorAll('[data-ap-field="' + fieldName + '"]')
          .forEach(function (field) {
            field.textContent = recoveryData[fieldName];
          });
      });
    }

    function restoreCopyControl() {
      copyButton.disabled = false;
      copyButton.removeAttribute("aria-busy");
      copyButton.textContent = "[ COPY DEPLOYMENT CODE ]";
    }

    function showError(message) {
      isRunning = false;
      terminal.classList.remove("is-running");
      loading.hidden = true;
      result.hidden = true;
      resetMeter();
      input.disabled = false;
      verifyButton.disabled = false;
      setVerifyLabel(verifyLabel);
      setStatus(message, "error");
      input.focus();
      input.select();
    }

    function showSuccess() {
      isRunning = false;
      terminal.classList.remove("is-running");
      loading.hidden = true;
      populateRecoveryRecord();
      result.hidden = false;
      input.disabled = true;
      verifyButton.disabled = true;
      setVerifyLabel("ARTIFACT RECOVERED");
      setStatus("ARTIFACT RECOVERED // READY FOR DEPLOYMENT", "success");
      result.focus();
    }

    function finishRecovery(enteredCode, version) {
      if (!isRunning || version !== lifecycleVersion) return;

      if (enteredCode === validCode) {
        showSuccess();
      } else {
        showError("INVALID RECOVERY CODE // ACCESS DENIED");
      }
    }

    function advanceRecovery(enteredCode, completedSegments, version) {
      if (!isRunning || version !== lifecycleVersion) return;

      var nextCompleted = completedSegments + 1;
      var stageIndex = Math.min(
        stages.length - 1,
        Math.floor(((nextCompleted - 1) / meterSegments.length) * stages.length),
      );
      var stageMessage = stages[stageIndex];

      stageLabel.textContent = stageMessage;
      setStatus(stageMessage, "running");
      updateMeter(nextCompleted);

      if (nextCompleted < meterSegments.length) {
        schedule(function () {
          advanceRecovery(enteredCode, nextCompleted, version);
        }, segmentDelay);
        return;
      }

      schedule(function () {
        finishRecovery(enteredCode, version);
      }, completionDelay);
    }

    function beginRecovery() {
      maskAllCharacters();
      if (isRunning) return;

      var enteredCode = normalizeCode(input.value);

      clearTimers();
      terminal.classList.remove("is-error", "is-success");
      result.hidden = true;
      loading.hidden = true;
      resetMeter();
      restoreCopyControl();

      if (!enteredCode) {
        showError("RECOVERY CODE REQUIRED");
        return;
      }

      lifecycleVersion += 1;
      var version = lifecycleVersion;
      isRunning = true;
      input.value = enteredCode;
      previousInputValue = enteredCode;
      renderMaskedValue(-1);
      input.disabled = true;
      verifyButton.disabled = true;
      setVerifyLabel("RECOVERY IN PROGRESS");
      terminal.classList.add("is-running");
      loading.hidden = false;
      stageLabel.textContent = stages[0];
      setStatus(stages[0], "running");

      if (prefersReducedMotion) {
        updateMeter(meterSegments.length);
        finishRecovery(enteredCode, version);
        return;
      }

      schedule(function () {
        advanceRecovery(enteredCode, 0, version);
      }, segmentDelay);
    }

    function clearTerminal(shouldFocus) {
      lifecycleVersion += 1;
      isRunning = false;
      clearTimers();
      terminal.classList.remove("is-running", "is-error", "is-success");
      clearMaskTimer();
      input.disabled = false;
      input.value = "";
      previousInputValue = "";
      renderMaskedValue(-1);
      loading.hidden = true;
      result.hidden = true;
      stageLabel.textContent = stages[0];
      resetMeter();
      verifyButton.disabled = false;
      setVerifyLabel(verifyLabel);
      restoreCopyControl();
      setStatus("AWAITING RECOVERY CODE");

      if (shouldFocus) {
        input.focus();
      }
    }

    function fallbackCopy(text) {
      return new Promise(function (resolve, reject) {
        var temporaryInput = document.createElement("textarea");
        temporaryInput.value = text;
        temporaryInput.setAttribute("readonly", "");
        temporaryInput.style.position = "fixed";
        temporaryInput.style.opacity = "0";
        temporaryInput.style.pointerEvents = "none";
        terminal.appendChild(temporaryInput);
        temporaryInput.select();

        try {
          var copied = document.execCommand("copy");
          temporaryInput.remove();

          if (copied) {
            resolve();
          } else {
            reject(new Error("Copy command was rejected."));
          }
        } catch (error) {
          temporaryInput.remove();
          reject(error);
        }
      });
    }

    function copyText(text) {
      if (
        navigator.clipboard &&
        typeof navigator.clipboard.writeText === "function" &&
        window.isSecureContext
      ) {
        return navigator.clipboard.writeText(text).catch(function () {
          return fallbackCopy(text);
        });
      }

      return fallbackCopy(text);
    }

    function selectDeploymentCode() {
      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(deploymentCodeElement);
      selection.removeAllRanges();
      selection.addRange(range);
      deploymentCodeElement.focus();
    }

    function copyDeploymentCode() {
      if (copyButton.disabled || result.hidden) return;

      var version = lifecycleVersion;
      copyButton.disabled = true;
      copyButton.setAttribute("aria-busy", "true");
      copyButton.textContent = "[ COPYING... ]";

      copyText(recoveryData.deploymentCode)
        .then(function () {
          if (version !== lifecycleVersion) return;

          copyButton.disabled = false;
          copyButton.removeAttribute("aria-busy");
          copyButton.textContent = "[ CODE COPIED ]";
          setStatus("DEPLOYMENT CODE COPIED // " + recoveryData.deploymentCode, "success");

          schedule(function () {
            if (version !== lifecycleVersion) return;
            restoreCopyControl();
            setStatus("ARTIFACT RECOVERED // READY FOR DEPLOYMENT", "success");
          }, 2200);
        })
        .catch(function () {
          if (version !== lifecycleVersion) return;

          restoreCopyControl();
          copyButton.textContent = "[ COPY UNAVAILABLE ]";
          setStatus(
            "COPY FAILED // SELECT THE DEPLOYMENT CODE MANUALLY",
            "error",
          );
          selectDeploymentCode();
        });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      beginRecovery();
    });

    input.addEventListener("input", updateMaskedDisplay);
    input.addEventListener("blur", maskAllCharacters);
    input.addEventListener("scroll", syncMaskScroll);

    resetButton.addEventListener("click", function () {
      clearTerminal(true);
    });

    copyButton.addEventListener("click", copyDeploymentCode);

    terminal.addEventListener("ap:terminal:destroy", function () {
      clearTerminal(false);
      delete terminal.dataset.apReady;
    });

    populateRecoveryRecord();
    clearTerminal(false);
  }

  function initAllTerminals(root) {
    var scope = root || document;

    if (scope.matches && scope.matches("[data-ap-terminal]")) {
      initTerminal(scope);
    }

    scope.querySelectorAll("[data-ap-terminal]").forEach(initTerminal);
  }

  function destroyTerminals(root) {
    var scope = root || document;

    if (scope.matches && scope.matches("[data-ap-terminal]")) {
      scope.dispatchEvent(new Event("ap:terminal:destroy"));
    }

    scope.querySelectorAll("[data-ap-terminal]").forEach(function (terminal) {
      terminal.dispatchEvent(new Event("ap:terminal:destroy"));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllTerminals(document);
    });
  } else {
    initAllTerminals(document);
  }

  if (document.documentElement.dataset.apTerminalEditorReady !== "true") {
    document.documentElement.dataset.apTerminalEditorReady = "true";

    document.addEventListener("shopify:section:load", function (event) {
      initAllTerminals(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      destroyTerminals(event.target);
    });
  }
})();